export default Object.freeze({
  Unspecified: 0,
  Free: 1,
  Trial: 2,
  Starter: 10,
  Basic: 20,
  Business: 30,
  Professional: 40,
  Enterprise: 50,
  DigitalTransformation: 60,
  Channel: 70,
  Custom: 90,
  Internal: 100,
});
